import React from 'react';
import {Box, BoxProps, Heading, Text} from 'components/ui/chakra';

interface SectionHeaderProps extends BoxProps {
	description?: React.ReactNode;
	eyebrow?: React.ReactNode;
	heading: React.ReactNode;
}

const SectionHeader = ({description, eyebrow, heading, ...rest}: SectionHeaderProps) => (
	<Box {...rest}>
		{eyebrow && (
			<Text
				color='subtleText'
				fontSize='0.72rem'
				fontWeight='700'
				letterSpacing='0.1em'
				textTransform='uppercase'
			>
				{eyebrow}
			</Text>
		)}
		<Heading as='div' fontSize={{base: 'lg', md: 'xl'}} mt={eyebrow ? 1.5 : 0}>
			{heading}
		</Heading>
		{description && (
			<Text color='subtleText' fontSize='sm' mt={2}>
				{description}
			</Text>
		)}
	</Box>
);

export default SectionHeader;
